import { React } from '@digsup/core-ui';

export const SpinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      id="Path_3120"
      data-name="Path 3120"
      d="M7.159,0a4.069,4.069,0,0,0-.073,1.1c-.146.144,5.394,1.079,7.64,5.514.83.815-1.1.911-.269,1.726L11.381,11.2,7.476,14.887,4.864,17.356.348,21.623l-.22.216A.473.473,0,0,0,.1,22.51l.708.671.708.7a.47.47,0,0,0,.656-.02l0,0,.22-.192L6.744,19.2l2.465-2.517c.708-.7,3.124-3.164,3.808-3.884l3-2.973c.22.24.122.072.366.288s.732-.791,1.367-.551a9.865,9.865,0,0,1,3.417,3.188c.146.072,2.734,4.579,2.807,4.483C22.683,9.565,18.655,7.1,18.655,7.1h0l.635-.647a.26.26,0,0,0,0-.36c-.366-.336-.708-.7-1.074-1.055a.272.272,0,0,0-.366,0l-.659.623h0C15.409,2.973,7.159,0,7.159,0Z"
      transform="translate(0.023)"
      fill="currentColor"
    />
  </svg>
);
